import { banco } from '../db/banco'
import { datasDeVisitaPorCliente } from '../visitas/logica'
import { somarDias } from '../visitas/retorno'
import { dataISOLocal } from '../pedidos/precos'
import type { DadosAvisos } from './regras'

// Chamado DENTRO do useLiveQuery: o Dexie observa o que e lido aqui e a bolinha
// atualiza sozinha ao resolver um aviso. Revisao final 2C: o sino vive em TODAS
// as telas, entao le SO a janela dos 7 dias pelos indices -- o pedido de HOJE
// (o que esta sendo montado) e seus itens ficam fora, e cada +/- na tela de
// Pedido nao recalcula o sininho. A janela e exata, nao aproximacao: nenhuma
// regra olha alem de hoje - 7.
export async function carregarDadosAvisos(agora: Date = new Date()): Promise<DadosAvisos> {
  const hoje = dataISOLocal(agora)
  const limite = somarDias(hoje, -7)
  const [a, m, d] = limite.split('-').map(Number)
  const desdeISO = new Date(a, m - 1, d).toISOString() // meia-noite LOCAL do limite
  const [compromissos, clientes, datasDeVisita, pedidos] = await Promise.all([
    banco.compromissos.where('data').aboveOrEqual(limite).toArray(),
    banco.clientes.toArray(),
    datasDeVisitaPorCliente(desdeISO),
    banco.pedidos.where('data').between(limite, hoje, true, false)
      .filter((p) => p.status === 'aberto' && p.apagado_em === null).toArray(),
  ])
  const ids = pedidos.map((p) => p.id)
  const subPedidos = ids.length ? await banco.sub_pedidos.where('pedido_id').anyOf(ids).toArray() : []
  const subIds = subPedidos.map((s) => s.id)
  const itens = subIds.length ? await banco.itens_pedido.where('sub_pedido_id').anyOf(subIds).toArray() : []
  return { compromissos, clientes, datasDeVisita, pedidos, subPedidos, itens }
}
